<template>
  <div>
    <PageTitle title="Connections" />
    <b-container fluid>
      <b-row>
        <b-col xs="12" sm="6" lg="5" xl="4">
          <Source class="fill-height" />
        </b-col>

        <b-col xs="12" sm="6" lg="5" xl="4">
          <Target class="fill-height" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import Source from '@/components/Source.vue';
import Target from '@/components/Target.vue';
import PageTitle from '@/components/PageTitle.vue';

export default defineComponent({
  name: 'Connections',
  components: {
    PageTitle,
    Source,
    Target,
  },
});
</script>
